import {
  mutationOptions,
  queryOptions,
  useMutation,
  useQuery,
  useQueryClient,
} from "@tanstack/react-query";
import __ from "src/utils/Translations";
import { dynamicNotification } from "src/utils/Notifications";
import { ICompanyConfigurationsResponse } from "src/Pages/Company/Absences/AbsencesConfiguration/AbsencesConfiguration.models";
import { fetchCompanyConfigurations, saveCompanyConfigurations } from "./api";
import { AbsenceQueryKeys } from "./config";

const CompanyConfigurationQueries = {
  byCompanyId: (companyId: string) =>
    queryOptions<ICompanyConfigurationsResponse, Error>({
      enabled: !!companyId,
      queryKey: AbsenceQueryKeys.companyConfigurations(companyId),
      queryFn: ({ signal }) => fetchCompanyConfigurations(companyId, signal),
    }),

  save: (companyId: string) =>
    mutationOptions({
      mutationFn: (formData: Parameters<typeof saveCompanyConfigurations>[1]) =>
        saveCompanyConfigurations(companyId, formData),
    }),
};

export const useFetchCompanyConfigurations = (companyId: string) =>
  useQuery(CompanyConfigurationQueries.byCompanyId(companyId));

export const useSaveCompanyConfigurations = (companyId: string) => {
  const queryClient = useQueryClient();

  return useMutation({
    ...CompanyConfigurationQueries.save(companyId),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: AbsenceQueryKeys.companyConfigurations(companyId),
      });
      dynamicNotification(__("Pomyślnie zapisano konfigurację."));
    },
    onError: () => {
      dynamicNotification(
        __("Nie udało się zapisać danych."),
        "error",
        "top-right",
        7000
      );
    },
  });
};

export default CompanyConfigurationQueries;
